import React from 'react';
import { Rating, Stack } from '@mui/material';
import { Nexset } from 'new/entities/Nexset';
import { IconButton } from 'new/elements/IconButton/IconButton';
import { useModals } from 'new/hooks/useModals';
import { ModalRateDataProduct } from 'new/elements/ModalRateDataProduct';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { ADD_DOMAIN_ITEM_RATING_REQUEST } from 'js/constants/actionTypes';
import CircularLoader from 'js/components/elements/progress/CircularLoader';

interface ItemRatingProps {
  item: Nexset;
  domainId: number;
}

const ItemRating = (props: ItemRatingProps) => {
  const { item, domainId } = props;
  const { openModal } = useModals();
  const isLoading = useIsLoading(ADD_DOMAIN_ITEM_RATING_REQUEST);

  const onClickRate = () => {
    openModal(ModalRateDataProduct.modalConfig.name, {
      item,
      domainId,
    });
  };

  return (
    <Stack minWidth="121px" alignItems="center">
      {isLoading ? (
        <CircularLoader size={20} thickness={2} />
      ) : (
        <IconButton onClick={onClickRate}>
          <Rating value={item?.rating} readOnly />
        </IconButton>
      )}
    </Stack>
  );
};

export default ItemRating;
